import script from "./HeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=4b00922e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b00922e"]])

export default __exports__